<template>
  <div>
    <NuxtLoadingIndicator color="#ccc" :height="5" />

    <NuxtLayout>
      <NuxtPage :page-key="route => route.fullPath" />
    </NuxtLayout>
  </div>
</template>
